const BLOCKED_DOMAIN_FAMILIES = [
  ['youtube.com', 'youtu.be', 'youtube-nocookie.com'],
];

const normalizeDomain = (value: string): string | null => {
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) return null;

  try {
    const parsed = new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`);
    return parsed.hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
};

export const expandBlockedDomains = (values: string[]): string[] => {
  const domains = values
    .map(normalizeDomain)
    .filter((domain): domain is string => Boolean(domain));
  const expanded = new Set(domains);

  for (const family of BLOCKED_DOMAIN_FAMILIES) {
    if (family.some(member => domains.includes(member))) {
      family.forEach(member => expanded.add(member));
    }
  }

  return Array.from(expanded);
};

export const isUrlBlocked = (url: string, blockedDomains: string[]): boolean => {
  try {
    const hostname = new URL(url).hostname.toLowerCase().replace(/^www\./, '');
    return expandBlockedDomains(blockedDomains).some(domain =>
      hostname === domain || hostname.endsWith(`.${domain}`),
    );
  } catch {
    return false;
  }
};
